import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Wrapper from "./components/Wrapper";
import CategoryDetail from "./pages/CategoryDetail";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import OrderDetail from "./pages/OrderDetail";

function App() {
    return (
        <Routes>
            <Route element={<Wrapper />}>
                <Route path="/" element={<Home />} />
                <Route
                    path="/products/:productId"
                    element={<ProductDetail />}
                />
                <Route
                    path="/categories/:categoryId"
                    element={<CategoryDetail />}
                />
                <Route path="/cart" element={<Cart />} />
                <Route
                    path="/order-detail/:orderId"
                    element={<OrderDetail />}
                />
            </Route>
        </Routes>
    );
}

export default App;
